import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ProduitService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "produit");
  }

  insertData(data) {
    console.log(data);
    return this.httpClient.post(environment.Localurl + "produit", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "produit/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "produit/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "produit/" + id, data);
  }

  maxproduit() {
    return this.httpClient.get(environment.Localurl + "maxproduit");
  }

  getProduitByCategorie(id) {
    return this.httpClient.get(
      environment.Localurl + "produitByCategorie/" + id
    );
  }

  dixclient() {
    return this.httpClient.get(environment.Localurl + "dixclient");
  }
  dixproduitvendus() {
    return this.httpClient.get(environment.Localurl + "dixproduitvendus");
  }
  nombreachat() {
    return this.httpClient.get(environment.Localurl + "nombreachat");
  }
}
